import { useTranslation } from 'react-i18next';
import { SelectTypeSkeleton } from '@components/forms/offline-sales/select-type-skeleton';
import { IconOfflineSale } from '@components/icons';
import { ModalHeader } from '@components/modals/modal-header';

import { EmptyState } from './empty-state';

export const OfflineSalesEntryGate = ({
  isCheckingAvailability,
  onClose,
}: {
  isCheckingAvailability: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  if (isCheckingAvailability) {
    return (
      <>
        <ModalHeader title={t('offers:offlineSalesTitle')} primaryIcon={IconOfflineSale} handleClose={onClose} />
        <div className='px-4 py-6 sm:px-20 sm:pb-12'>
          <SelectTypeSkeleton rows={1} />
        </div>
      </>
    );
  }

  return <EmptyState onClose={onClose} />;
};
